"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.2
var Tabbed_Sections = void 0;

Tabbed_Sections = function Tabbed_Sections() {
  var tabbed_container = void 0;
  tabbed_container = (0, _jquery2.default)(".tabbed-container");
  return {
    init: function init() {
      var me = void 0;
      me = this;
      return (0, _jquery2.default)(".tabbed-nav a").on("click", function (e) {
        var new_tab_section = void 0;
        var tab = void 0;
        e.preventDefault();
        new_tab_section = (0, _jquery2.default)(this).attr("href");

        tab = (0, _jquery2.default)(this).parents(".tab");
        return me.switch_tab(tab, new_tab_section);
      });
    },
    switch_tab: function switch_tab(tab, new_tab) {
      var activateTimeout = void 0;
      (0, _jquery2.default)(".tabbed-nav .tab").removeClass("active");
      tab.addClass("animating");
      tabbed_container.addClass("animating");
      (0, _jquery2.default)(".tabbed-section").removeClass("visible-tab").addClass("hidden-tab");
      clearTimeout(activateTimeout);
      return activateTimeout = setTimeout(function () {
        tabbed_container.removeClass("animating");
        (0, _jquery2.default)(".tabbed-section").removeClass("visible-tab").addClass("hidden-tab");
        (0, _jquery2.default)(".tabbed-nav .tab").removeClass("active");
        tab.removeClass("animating").addClass("active");
        (0, _jquery2.default)(new_tab).removeClass("hidden-tab").addClass("visible-tab");
        if (new_tab === "#brief") {
          (0, _jquery2.default)("#upload-button").addClass("on-brief").removeClass("bottom stuck");
          return (0, _jquery2.default)(".key-requirements").addClass("on-brief").removeClass("bottom stuck");
        } else {
          return (0, _jquery2.default)("#upload-button").removeClass("on-brief");
        }
      }, 350);
    }
  };
};

exports.default = Tabbed_Sections().init();